export default __webpack_public_path__ + "static/media/favicon-animado.487fa2ca.ico";